// 组件对象，大写
import validDateCompute from './validDateCompute.vue'
export default validDateCompute
